const configuredApiBase = import.meta.env.VITE_API_BASE;
const configuredApiIsWorker = configuredApiBase?.startsWith("http") && !/\/\/(?:127\.0\.0\.1|localhost):5173\b/.test(configuredApiBase);

export const API_BASE = configuredApiIsWorker ? configuredApiBase : "https://soulsmith-api.centraldanike.workers.dev";
export const WORLD_SEED = 863104;
export const SUPPORTED_LANGS = ["en", "pt", "es", "de", "fr"] as const;
